import { useLocation } from 'react-router-dom'

const useQueryParams = (param: string) => {
  const url = new URLSearchParams(useLocation().search)
  return url.get(param) as string
}

export default useQueryParams
